import { DataDeliveryAdminOrganizationMetadataService, OrganizationMetadataDTO } from '@om1/falcon-api'
import { handleApiError } from '@om1/falcon-api/utils'
import { call, put } from 'redux-saga/effects'
import { generalSettingsActions } from '../state/general-settings'

export function createGetOrganizationSettingsSaga() {
    return function* () {
        try {
            yield put(generalSettingsActions.setOrganizationSettingsLoading({ loading: true }))
            const organizationMetadata: OrganizationMetadataDTO | null = yield call(
                DataDeliveryAdminOrganizationMetadataService.getCurrentOrgDataDeliveryOrganizationMetadataOrgidGet
            )
            yield put(generalSettingsActions.setOrganizationSettings({ organizationMetadata }))
        } catch (error) {
            yield handleApiError(error)
        } finally {
            yield put(generalSettingsActions.setOrganizationSettingsLoading({ loading: false }))
        }
    }
}
